import { render, staticRenderFns } from "./ActivateServicesDoc.vue?vue&type=template&id=b4e4d89a"
import script from "./ActivateServicesDoc.vue?vue&type=script&lang=js"
export * from "./ActivateServicesDoc.vue?vue&type=script&lang=js"
import style0 from "./ActivateServicesDoc.vue?vue&type=style&index=0&id=b4e4d89a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports